import ZadaraCloud from "public/privateCloud/icons/zadara-cloud.png";
import { MAIN_ROUTES, CLOUD_MIGRATIONS_ROUTES } from "@/constants/routes";

export const ZADARA_SERVICES_CONSTANTS = {
  title: "Zadara Cloud Services",
  desc: "Zadara Cloud offers a range of services to meet diverse business needs, enabling organizations to focus on innovation and growth rather than infrastructure management.",
  list: [
    {
      image: ZadaraCloud,
      title: "zCompute",
      content:
        "Develop, deploy, and run applications with secure and flexible compute resources, including support for GPU acceleration and containerized workloads.",
    },
    {
      image: ZadaraCloud,
      title: "zStorage",
      content:
        "Access scalable and high-performance storage solutions compatible with various data types and protocols, ensuring seamless integration with existing systems.",
    },
    {
      image: ZadaraCloud,
      title: "zNetworking",
      content:
        "Implement advanced networking features to ensure secure and efficient connectivity across all deployed services.",
    },
    {
      image: ZadaraCloud,
      title: "Zadara SE Storage",
      content:
        "Access secure, scalable, and high-performance storage solutions designed to handle any data type and protocol, ensuring seamless integration with your existing infrastructure. ",
    },
    {
      image: ZadaraCloud,
      title: "Zadara GPU",
      content:
        "Leverage NVIDIA's powerful GPUs within Zadara's cloud infrastructure to accelerate AI, machine learning, and data-intensive applications with unparalleled performance and efficiency. ",
    },
  ],
  conclusion:
    "These services are designed to provide a seamless and efficient experience, enabling businesses to focus on innovation and growth rather than infrastructure management. ",
};
